import loadable from '@loadable/component';

export default loadable(() => import('./Chart'), {ssr: false});
